const sideModalKey = "sideModalKey";

export { sideModalKey };
